import { clsx } from 'clsx';

type StatusPillVariant =
  | 'active'
  | 'recording'
  | 'listening'
  | 'ended'
  | 'completed'
  | 'terminated'
  | 'unknown';

const PILL_TEXT_CLASS = 'text-unilink-text-primary';

const VARIANT_CLASS: Record<StatusPillVariant, string> = {
  active: clsx('bg-status-active-bg', PILL_TEXT_CLASS),
  recording: clsx('bg-status-recording-bg', PILL_TEXT_CLASS),
  listening: clsx('bg-status-listening-bg', PILL_TEXT_CLASS),
  ended: clsx('bg-gray-200', PILL_TEXT_CLASS),
  completed: clsx('bg-status-active-bg', PILL_TEXT_CLASS),
  terminated: clsx('bg-status-terminated-bg', PILL_TEXT_CLASS),
  unknown: clsx('bg-status-neutral-bg', PILL_TEXT_CLASS),
};

type StatusPillProps = {
  variant: StatusPillVariant;
  children: string;
  compact?: boolean;
};

export function StatusPill({ variant, children, compact = false }: StatusPillProps) {
  return (
    <span
      className={clsx(
        'inline-flex items-center justify-center rounded-full font-semibold',
        compact ? 'h-5 px-4 text-xs leading-4' : 'h-6 px-4 text-sm leading-4',
        VARIANT_CLASS[variant]
      )}
    >
      {children}
    </span>
  );
}
